import { init } from "@sentry/browser";

if (process.env.NODE_ENV === "production") {
    console.log("init sentry");
    // init({
    //     dsn: "https://00195fcfc54f401e924512f66fd7a4bd@sentry.eqwile.com/24"
    // });
}
